import React from "react"
import DataTable from "ui/DataTable"
import PropTypes from "prop-types"
import crewMembersColumns from "./columns"
import { usePermissions } from "hooks/usePermissions"

const CrewMembersTable = ({ data, onChange, loading, onEdit, onDelete }) => {
    const { hasPermission } = usePermissions()
    const columns = crewMembersColumns(onEdit, onDelete, hasPermission)
    return <DataTable columns={columns} dataSource={data} pagination={false} onChange={onChange} loading={loading} />
}

CrewMembersTable.propTypes = {
    data: PropTypes.arrayOf(PropTypes.object),
    onChange: PropTypes.func,
    loading: PropTypes.bool,
    onEdit: PropTypes.func,
    onDelete: PropTypes.func
}

export default React.memo(CrewMembersTable)
